import { Outlet } from 'react-router-dom';
import { OnlineBanner } from '@/components/OnlineBanner';
import { Sidebar } from '@/components/layout/Sidebar';
import { IconButton } from '@/components/ui/IconButton';
import { SidebarLayoutProvider, useSidebarLayout } from '@/contexts/SidebarLayoutContext';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';
import { PanelLeft, PanelRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

function AppShellContent() {
  const online = useOnlineStatus();
  const { setMobileOpen } = useSidebarLayout();
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === 'rtl';
  const MenuIcon = isRtl ? PanelRight : PanelLeft;

  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden">
      <OnlineBanner />
      <div className="flex min-h-0 min-w-0 flex-1 items-stretch">
        <Sidebar />
        <div className="flex min-w-0 w-full flex-1 flex-col">
          <div className="flex shrink-0 items-center border-b border-[var(--fv-border)] px-4 py-2 md:hidden">
            <IconButton
              variant="ghost"
              aria-label={t('layout.sidebar.openMenu')}
              onClick={() => setMobileOpen(true)}
            >
              <MenuIcon className="h-5 w-5" aria-hidden />
            </IconButton>
          </div>
          <main
            className="min-w-0 flex-1 overflow-y-auto p-4 md:p-6"
            style={!online ? { pointerEvents: 'none', opacity: 0.65 } : undefined}
          >
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}

export function AppShell() {
  return (
    <SidebarLayoutProvider>
      <AppShellContent />
    </SidebarLayoutProvider>
  );
}
